import { Model } from 'pinia-orm';

export default class Category extends Model {
  static entity = 'categories';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      label: this.attr(''),
      slug: this.attr(''),

    };
  }


}
